'use client'

import React, { Fragment } from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import FaqButton from './FaqButton'
import ChatInput from './ChatInput'
import styles from './QuickActions.module.scss'

interface FaqButtonIcon {
  id?: number
  url?: string
  alternativeText?: string | null
  data?: {
    attributes?: {
      url?: string
      alternativeText?: string | null
    }
  }
}

interface FaqButtonItem {
  id: number
  text: string
  icon?: FaqButtonIcon
}

interface QuickActionCardProps {
  id?: number
  title?: string
  faqButtons?: FaqButtonItem[]
  triggerCopilot?: (message: string | undefined) => void
}

const getConcatenatedText = (text: String | undefined): string => {
  if (!text) return ''
  return text.toLowerCase().split(' ').join('_')
}

const QuickActions = ({ title, faqButtons, triggerCopilot }: QuickActionCardProps) => {
  if (!faqButtons || faqButtons.length === 0) {
    return null
  }

  const handleCtaClick = async (msg: string | undefined) => {
    if (triggerCopilot) {
      triggerCopilot(msg)
    }
    const event = msg?.length ? CONTACT_US_EVENTS.QUICK_ACTIONS_CLICKED : CONTACT_US_EVENTS.CHAT_NOW_SUPPORT_CLICKED

    await trackEvent(event.eventName, {
      ...event.eventProps,
      type: getConcatenatedText(title),
      cta_text: msg,
      platform: getDevicePlatform(),
    })
  }
  return (
    <div className={styles.quickActionCard}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.faqSection}>
        {faqButtons.map((btn, index) => (
          <Fragment key={btn.id || index}>
            <FaqButton
              btn={btn}
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              handleClick={handleCtaClick}
            />
            {index < faqButtons.length - 1 && <hr className={styles.separator} />}
          </Fragment>
        ))}
      </div>
      <ChatInput
        placeholder="Ask something else..."
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSend={handleCtaClick}
      />
    </div>
  )
}

export default QuickActions
